/* eslint-disable no-useless-escape */
import React from 'react';
import PropTypes from 'prop-types';
// import { max } from 'date-fns';

// eslint-disable-next-line max-len
function EmailInput({
  fieldName,
  register,
  errors,
  label,
  placeHolder,
  className,
  labelstyle,
  labeldarkstyle,
  classNamedark,
  isRequired,
  mandatory,
  defaultValue,
  section,
  maxLength,
}) {
  let classNames = labelstyle;
  let classNamess = className;

  if (localStorage.getItem('theme') === 'dark') {
    classNames = labeldarkstyle;
    classNamess = classNamedark;
  }
  const handleKeyDown = (e) => {
    if (e.key === ' ') {
      e.preventDefault();
    }
    if (e.keyCode === 13) {
      const { form } = e.target;
      const index = Array.prototype.indexOf.call(form, e.target);
      form.elements[index + 1].focus();
      e.preventDefault();
    }
  };

  return (
    <div className="form-group">
      <label htmlFor={fieldName} className={classNames ?? labelstyle}>
        {label ?? ' '}
        {mandatory ? <span style={{ color: 'red', marginLeft: '3px' }}>*</span> : <span />}
      </label>

      <input
        type="text"
        defaultValue={defaultValue}
        className={classNamess ?? className}
        placeholder={placeHolder ?? 'Email'}
        onKeyDown={handleKeyDown}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...register(fieldName ?? 'email', {
          required: {
            value: isRequired,
            message: `${
              section === 'physiotherapist' ? 'Physiotherapist email' : label
            } is required.`,
          },
          maxLength: {
            value: maxLength ?? 62, // You can set a default max length here
            message: `${
              section === 'physiotherapist' ? 'Physiotherapist email' : label
            } should not exceed ${maxLength ?? 62} characters.`,
          },
          // pattern: {
          //   value:
          //     /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
          //   message: 'Please enter a valid email.',
          // },
          pattern: {
            value:
              /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@(([a-zA-Z0-9-]+\.)+(com|org|net|edu|gov|mil|info|biz|io|co|us|uk|ca|au|de|fr|jp|ru|cn|it|es|nl|se|no|fi|dk|ch|be|br|za))$/,
            message: 'Please enter a valid email.',
          },
        })}
      />

      <p
        style={{
          color: 'red',
          marginTop: '5px',
          fontSize: '14px',
        }}
      >
        {' '}
        {
          // Shows if error exist
          errors[fieldName] && errors[fieldName].message
        }{' '}
      </p>
    </div>
  );
}

EmailInput.propTypes = {
  fieldName: PropTypes.string.isRequired,
  register: PropTypes.func.isRequired,
  errors: PropTypes.oneOfType([PropTypes.object]).isRequired,
  placeHolder: PropTypes.string,
  label: PropTypes.string,
  className: PropTypes.string.isRequired,
  isRequired: PropTypes.bool,
  labelstyle: PropTypes.string.isRequired,
  mandatory: PropTypes.bool,
  classNamedark: PropTypes.string,
  labeldarkstyle: PropTypes.string,
  defaultValue: PropTypes.string,
  section: PropTypes.string,
  maxLength: PropTypes.number,
};
EmailInput.defaultProps = {
  mandatory: false,
  isRequired: false,
  maxLength: 100,
  labeldarkstyle: null,
  classNamedark: null,
  placeHolder: 'Enter Email',
  label: '',
  defaultValue: '',
  section: '',
};
export default EmailInput;
